module.exports = __webpack_public_path__ + "static/media/web logos_Team GB.64231bf0.jpg";